import { Link } from "react-router-dom";
import { HOME } from "@/constants/testIds";

/**
 * MACHA wordmark — text only.
 * Display type (Outfit) at slightly tighter tracking for a premium feel.
 */
export function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      data-testid={HOME.navLogo}
      className={`group inline-flex items-center ${className}`}
    >
      <span className="font-display text-[18px] font-bold tracking-[0.04em] text-foreground transition-colors group-hover:text-primary">
        MACHA
      </span>
    </Link>
  );
}
